export const inboxQueries = ['getConversation', 'getConversations', 'getInboxes']
